
import React from 'react';
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";

interface ParcelFormHeaderProps {
  index: number;
  canRemove: boolean;
  onRemove: (index: number) => void;
}

const ParcelFormHeader: React.FC<ParcelFormHeaderProps> = ({
  index,
  canRemove,
  onRemove
}) => {
  return (
    <div className="flex items-center justify-between">
      <h3 className="text-lg font-medium">Parcel Info {index + 1}</h3>
      {canRemove && (
        <Button
          variant="outline"
          size="sm"
          onClick={() => onRemove(index)}
          className="validation-error hover:validation-error"
        >
          <Trash2 className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
};

export default ParcelFormHeader;
